// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QmLM","content":"styles_content__NCpzJ"};